import { Group, Paper, Stack, Text, Title } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { isHtmlEmpty } from "@/utils/rich-text";

export default function EncounterFormNoteReview({
  value,
  title,
}: {
  value: string | undefined;
  title: string;
}) {
  const summary = value || "";
  const hasNote = !isHtmlEmpty(summary);

  return (
    <Paper radius="lg" mb={{ base: "xs", xs: "xl" }}>
      <Group justify="space-between" mx={{ base: "xs", md: "xl" }}>
        <Stack gap={0} pb={{ base: 0, xs: "xs" }} pt={{ base: "xs", xs: "md", sm: "lg", md: "xl" }}>
          <Title order={3} c="burgundy.9">
            {title}
          </Title>
        </Stack>
      </Group>

      {hasNote ? (
        <Text
          px={{ base: "xs", md: "xl" }}
          pb={{ base: "xs", xs: "xl" }}
          dangerouslySetInnerHTML={{ __html: value || "" }}
        />
      ) : (
        <TextWrapper c="gray.7" px={{ base: "xs", md: "xl" }} pb={{ base: "xs", xs: "xl" }}>
          No encounter note has been added.
        </TextWrapper>
      )}
    </Paper>
  );
}
